import { useEffect, useState } from "react";

const storageKey = "pf-cookie-notice-v1";

export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      setVisible(localStorage.getItem(storageKey) !== "acknowledged");
    } catch {
      setVisible(true);
    }
  }, []);

  function dismiss() {
    try {
      localStorage.setItem(storageKey, "acknowledged");
    } catch {
      // The notice can still be dismissed when browser storage is unavailable.
    }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <aside className="cookie-notice" aria-label="Cookies and browser storage">
      <p>
        We use an essential cookie to keep you signed in and browser storage to
        remember your preferences. No analytics or advertising cookies.{" "}
        <a href="/privacy#browser-storage">Learn more</a>
      </p>
      <button type="button" onClick={dismiss}>Got it</button>
    </aside>
  );
}
